import { Versions } from '../constants/versions';
import { IStatementRef } from '../resources/istatement/statement_ref';

export interface StatementRefParams {
	id?: string;
	objectType?: string;
}

export class StatementRef {
	id?: string;
	objectType: string = 'StatementRef';

	constructor(cfg: StatementRefParams) {
		this.init(cfg);
	}

	init(cfg: StatementRefParams = {}): void {
		this.id = cfg.id;
	}

	toString(): string | undefined {
		return this.id;
	}

	asVersion(version: Versions = '1.0.3'): IStatementRef {
		const result: IStatementRef = {
			objectType: this.objectType,
			id: this.id
		};

		return result;
	}

	static fromJSON(stRefJSON: string): StatementRef {
		const _stRef = JSON.parse(stRefJSON);

		return new StatementRef(_stRef);
	}
}
